import Vue from 'vue';
import Component from 'vue-class-component';
import REQ_URL from '@/consts/req-url';
import Slider from '@/components/Slider/Slider';
import SliderElement from '@/components/Slider/SliderElement';

@Component({
    components: {
        Slider,
        SliderElement
    }
})
export default class Banner extends Vue {
    slider: string[] = []
    disable = false
    mounted() {
        this.setBanner()
    }
    activated() {
        this.disable = false
    }
    deactivated() {
        this.disable = true
    }
    async setBanner() {
        try {
            let data = await this.$fetch<string[]>(REQ_URL.GET_MAIN_BANNER)
            if (data.body) this.slider = data.body
            else throw new Error('Некорректные данные ответа')
        } catch (error) {
            console.error(error)
            this.disable = true
        }
    }
}